const questions = {
  tag: 'Be sure to answer honestly, even if it hurts.',
};

export default questions;



// WEBPACK FOOTER //
// ./src/locales/questions.js